import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import Slider, { Settings } from 'react-slick';
import { Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { createPreviewMessageEventHandler } from '@shared/utils/previewMessageBus';
import globalWindow from '@shared/core/globals';

export const useSliderSettings = () => {
  const sliderRef = useRef<Slider | null>(null);

  const settings: Settings = useMemo(
    () => ({
      dots: true,
      infinite: true,
      waitForAnimate: false,
      // animation speed
      speed: 2500,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      autoplay: true,
      // speed between slides on autoplay
      autoplaySpeed: 6000,
      cssEase: 'ease',
      pauseOnHover: false,
      // dot styling
      customPaging: () => <Box className="custom-dot" width={{ _: pxToRem(20), xs: 8, sm2: pxToRem(46) }} height={1} borderRadius="full" backgroundColor="white" />
    }),
    []
  );

  const goToSlide = useCallback((slideIndex: number) => {
    sliderRef.current?.slickGoTo(slideIndex, true);
  }, []);

  useEffect(() => {
    const receiveMessage = createPreviewMessageEventHandler(message => {
      if (message.action === 'fromList') {
        message.value.forEach(result => {
          switch (result.key) {
            case 'sliderGoToSlideIndex':
              goToSlide(result.value);
              break;
          }
        });
      }
    });
    globalWindow.addEventListener?.('message', receiveMessage, false);
    return () => {
      globalWindow.removeEventListener?.('message', receiveMessage, false);
    };
  }, [goToSlide]);

  return { settings, sliderRef };
};
